<template>
  <div class="app-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FullScreenLayout',
}
</script>
